import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEye = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M17.915 9.21c.175.247.263.37.309.55a1.11 1.11 0 0 1 0 .48c-.046.18-.134.303-.31.55-1.196 1.68-4.288 5.46-7.914 5.46-3.626 0-6.719-3.78-7.915-5.46-.175-.247-.263-.37-.309-.55a1.11 1.11 0 0 1 0-.48c.046-.18.134-.303.31-.55C3.28 7.53 6.373 3.75 10 3.75c3.626 0 6.718 3.78 7.915 5.46Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M12.25 10a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
		})
	]
});
const ForwardRef = forwardRef(SvgEye);
export { ForwardRef as ReactComponent };
